import { render, staticRenderFns } from "./Harvests.vue?vue&type=template&id=3d63b800&scoped=true&lang=html&"
import script from "./Harvests.vue?vue&type=script&lang=js&"
export * from "./Harvests.vue?vue&type=script&lang=js&"
import style0 from "./Harvests.vue?vue&type=style&index=0&id=3d63b800&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d63b800",
  null
  
)

export default component.exports